// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  cursor: pointer;
  text-decoration: none;
  color: #000;
}

.card .card-header,
.card .card-footer {
  font-size: 1.2rem;
  background-color: #c9e8fb;
}
.card .card-header .card-title,
.card .card-footer .card-title {
  color: #000;
}

ul {
  margin-bottom: 0;
  padding-inline-start: 1rem;
}`, "",{"version":3,"sources":["webpack://./libs/msslib/src/lib/components/card-deck/card-deck.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,qBAAA;EACA,WAAA;AADF;;AAKE;;EAEE,iBAAA;EACA,yBAAA;AAFJ;AAII;;EACE,WAAA;AADN;;AAMA;EACE,gBAAA;EACA,0BAAA;AAHF","sourcesContent":["@use 'mssvariables' as *;\n\na {\n  cursor: pointer;\n  text-decoration: none;\n  color: theme-color('dark');\n}\n\n.card {\n  .card-header,\n  .card-footer {\n    font-size: 1.2rem;\n    background-color: theme-color('pastel-blue');\n\n    .card-title {\n      color: theme-color('dark');\n    }\n  }\n}\n\nul {\n  margin-bottom: 0;\n  padding-inline-start: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
